import React, { Component } from 'react';
import QuickSearchResult from './QuickSearchResult';
import QuickSearchResultEmpty from './QuickSearchResultEmpty';
import { translate } from '../Services/translation';

class QuickSearch extends Component {
  constructor(props) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.toggleSubMenu = this.toggleSubMenu.bind(this);
    this.handleFixedSearchState = this.handleFixedSearchState.bind(this);
    this.toggleFocused = this.toggleFocused.bind(this);
    this.handleClickCourtain = this.handleClickCourtain.bind(this);
    this.trapFocus = this.trapFocus.bind(this);
    this.hasSearchInput = false;


    this.state = {
      focused: false,
      searchInput: '',
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('keydown', this.trapFocus);

    const url = window.location.search;
    const params = new URLSearchParams(url);
    const queryParam = params.get('q');

    if (queryParam) {
      this.setState({
        ...this.state,
        searchInput: queryParam,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('keydown', this.trapFocus);
  }

  trapFocus(e) {
    if (!this.state.focused || !this.wrapperRef) return;

    if (e.key === 'Tab') {
      const focusableEls = this.wrapperRef.querySelectorAll(
        'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
      );
      const focusable = Array.from(focusableEls);
      if (!focusable.length) return;

      const firstEl = focusable[0];
      const lastEl = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        }
      } else {
        if (document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
      }
    }

    if (e.key === 'Escape') {
      this.handleClose();
    }
  };

  handleClickOutside(event) {
    const {
      showFullForm,
      closeOverlay,
      clearResults,
      toggleShowFullForm,
      query,
    } = this.props;

    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({
        ...this.state,
        searchInput: query,
      });

      showFullForm && closeOverlay();
      showFullForm && toggleShowFullForm();
      showFullForm && clearResults();
      showFullForm && this.toggleFocused();
    }
  }

  handleClose() {
    const {
      showFullForm,
      closeOverlay,
      clearResults,
      toggleShowFullForm,
    } = this.props;

    this.setState({
      ...this.state,
      searchInput: '',
    });

    showFullForm && closeOverlay();
    showFullForm && toggleShowFullForm();
    showFullForm && clearResults();
    showFullForm && this.toggleFocused();
  }

  toggleSubMenu() {
    const subMenuButton = document.querySelector(
      '.navbar__submenu-item--link'
    );
    if (subMenuButton !== null) {
      if (
        subMenuButton.parentElement.classList.contains(
          'show-sortiment-menu'
        )
      ) {
        subMenuButton.parentElement.classList.remove(
          'show-sortiment-menu'
        );
      } else return;
    } else return;
  }

  toggleFocused() {
    const { onSearch } = this.props;

    this.setState(prevState => ({
      focused: !prevState.focused,
    }));

    this.hasSearchInput = !this.hasSearchInput;

    if (this.hasSearchInput && this.state.searchInput) {
      onSearch(this.state.searchInput);
    }

    this.toggleSubMenu();

    document.body.classList.toggle('no-scroll');

    // Close expanded mobile menu
    let mobileMenu = document.querySelector('.navbar__menu--show');
    let menuIcon = document.querySelector('.navbar__icon--menu');
    let mobileMenuOverlay = document.querySelector('.navbar__courtain');

    if (mobileMenu) {
      mobileMenu.classList.remove('navbar__menu--show');
      menuIcon.classList.remove('expanded');
      mobileMenuOverlay.classList.remove('show');
    }

    // Close expanded mega menu
    let navItem = document.querySelector('.navbar__item.expanded');

    if (navItem) {
      navItem.classList.remove('expanded');
    }
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleFixedSearchState() {
    const { openOverlay } = this.props;

    setTimeout(() => {
      openOverlay();
    }, 0);
  }

  handleClickCourtain() {
    const {
      showFullForm,
      closeOverlay,
      clearResults,
      toggleShowFullForm,
      query,
    } = this.props;

    this.setState({
      ...this.state,
      searchInput: query,
    });

    showFullForm && closeOverlay();
    showFullForm && toggleShowFullForm();
    showFullForm && clearResults();
    showFullForm && this.toggleFocused();
  }

  render() {
    const {
      query,
      result,
      isMobile,
      showResult,
      onSearch,
      onKeyDown,
      onIconSearch,
      toggleShowFullForm,
      selectedItem,
      searchUrl,
    } = this.props;
    let hasOwnProperty =
      Object.getOwnPropertyNames(result).length > 0 ? true : false;
    let header = document.getElementById('header');
    let headerHeight = header.offsetHeight;
    const curtainHeight = `calc(100% - ${headerHeight}px`;

    return (
      <div
        ref={this.setWrapperRef}
        className={`quick-search quick-search--expanded`}
        role="search"
      >
        {this.state.focused && (
          <div
            className="quick-search__courtain"
            onClick={() => this.handleClickCourtain()}
            style={{ height: curtainHeight, top: headerHeight - 1 }}
          ></div>
        )}
        <div className="quick-search__form">
          <div className="quick-search__form-inner">
            <label htmlFor="quick-search-input">{translate('general.search')}</label>
            <input
              autoComplete="off"
              className="quick-search__input"
              id="quick-search-input"
              onChange={event => {
                onSearch(
                  encodeURIComponent(event.target.value)
                ),
                  this.setState({
                    ...this.state,
                    searchInput: event.target.value,
                  });
              }}
              onKeyDown={event => onKeyDown(event, { searchUrl })}
              placeholder={translate('general.search')}
              onClick={() => {
                this.handleFixedSearchState(),
                  !this.state.focused && this.toggleFocused(),
                  !this.state.focused && toggleShowFullForm();
              }}
              ref={input => {
                this.searchInput = input;
              }}
              type="search"
              value={
                this.state.searchInput
                  ? decodeURIComponent(this.state.searchInput)
                  : decodeURIComponent(query)
              }
            />

            {this.state.focused && (
              <button
                className="quick-search__submit-button"
                onClick={() => this.handleClose()}
              >
                <i
                  className="quick-search__close-icon quick-search__close-icon--green"
                  tabIndex="-1"
                ></i>
              </button>
            )}

            {!this.state.focused && (
              <button
                id="quick-search-submit"
                className="quick-search__submit-button"
                type="submit"
                onClick={event =>
                  onIconSearch(event, { searchUrl })
                }
                aria-label={translate('general.search')}
              >
                <i className="quick-search__submit-icon quick-search__submit-icon--green" tabIndex="-1"></i>
              </button>
            )}

            {showResult &&
              decodeURIComponent(query).length >= 3 && (
                <QuickSearchResult
                  result={result}
                  searchUrl={searchUrl}
                  selectedItem={selectedItem}
                  isMobile={isMobile}
                  query={query}
                />
              )}
            {!showResult &&
              decodeURIComponent(query).length >= 3 &&
              hasOwnProperty && (
                <QuickSearchResultEmpty result={result} />
              )}
          </div>
        </div>
      </div>
    );
  }
}

export default QuickSearch;